<template>
  <div class="shadow-type">
    <ai-clear-button
      v-for="type in typesList"
      :key="type.value"
      class="shadow-type__item"
      :class="{ 'shadow-type__item--active': props.modelValue === type.value }"
      @click="updateTypeHandler(type.value)"
    >
      <inline-svg :src="type.icon" />
      {{ type.name }}
    </ai-clear-button>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch, PropType } from 'vue';
import i18n from '@/plugins/i18n';
import { useI18n } from 'vue-i18n';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';

interface IType {
  name: string;
  value: number;
  icon: any;
}

const { t } = useI18n();

const emits = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Number as PropType<number>,
    required: true,
  },
});

const typesList = ref<IType[]>([
  {
    name: t('shadow.front'),
    value: 0,
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/shadow/front.svg'),
  },
  {
    name: t('shadow.top'),
    value: 1,
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/shadow/position/top-position.svg'),
  },
  {
    name: t('shadow.isometric'),
    value: 2,
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/shadow/isometric.svg'),
  },
]);

const lang = computed(() => i18n.global.locale.value);

const updateTypeHandler = (newVal: number): void => {
  emits('update:modelValue', newVal);
};

watch(lang, () => {
  typesList.value = [
    {
      name: t('shadow.front'),
      value: 0,
      // eslint-disable-next-line global-require
      icon: require('@/assets/icons/shadow/front.svg'),
    },
    {
      name: t('shadow.top'),
      value: 1,
      // eslint-disable-next-line global-require
      icon: require('@/assets/icons/shadow/position/top-position.svg'),
    },
    {
      name: t('shadow.isometric'),
      value: 2,
      // eslint-disable-next-line global-require
      icon: require('@/assets/icons/shadow/isometric.svg'),
    },
  ];
});
</script>

<style scoped lang="scss" src="./ShadowType.scss" />
